import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';

import HtmlElement from '../HtmlElement';

const defaultProps = {
  initialValues: {},
  validationSchema: {},
  validateOnChange: true,
  validateOnBlur: true,
  className: '',
  onSubmit: () => {},
};

const propTypes = {
  initialValues: PropTypes.shape(),
  validationSchema: PropTypes.shape(),
  validateOnChange: PropTypes.bool,
  validateOnBlur: PropTypes.bool,
  className: PropTypes.string,
  onSubmit: PropTypes.func,
  children: PropTypes.func.isRequired,
};

const Form = ({
  initialValues,
  validationSchema,
  onSubmit,
  validateOnChange,
  validateOnBlur,
  className,
  children,
}) => (
  <Formik
    initialValues={initialValues}
    validationSchema={validationSchema}
    onSubmit={onSubmit}
    validateOnChange={validateOnChange}
    validateOnBlur={validateOnBlur}
  >
    {({
      values,
      errors,
      touched,
      handleChange,
      handleBlur,
      handleSubmit,
      isSubmitting,
    }) => (
      <HtmlElement
        tagName="form"
        onSubmit={handleSubmit}
        className={className}
      >
        {children({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          isSubmitting,
        })}
      </HtmlElement>
    )}
  </Formik>
);

Form.defaultProps = defaultProps;
Form.propTypes = propTypes;

export default Form;
